import "./Updation.css";
import { Link } from "react-router-dom";
import React from "react";

class Block extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			blockValue: Math.floor(Math.random() * 100),
		};
	}

	componentDidMount() {
		document.title = "Updation in Arrays | Array Bundle";
		window.scroll(0, 0);
	}

	render() {
		return (
			<div id={this.props.id} className="upd-arr-block">
				<input
					style={{ textAlign: "center" }}
					placeholder={this.state.blockValue}
				/>
			</div>
		);
	}
}

let arr = [];
let randomElement = Math.floor(Math.random() * 10) + 2;

for (let i = 0; i < 10; i++) {
	arr.push(<Block id={"upd_" + String(i)} />);
}

function checkUpdation() {
	for (let i = 0; i < 10; i++) {
		let elem = document.getElementById("upd_" + String(i));
		let ph = parseInt(elem.children[0].placeholder);
		let val = parseInt(elem.children[0].value);
		if (ph % randomElement == 0 && val != "") {
			if (val == ph + 1) {
				document.getElementById("check-header").style.color =
					"greenyellow";
				document.getElementById("check-header").innerText =
					"Great job! Head on to the next subbundle.";
			} else {
				document.getElementById("check-header").style.color =
					"orangered";
				document.getElementById("check-header").innerText =
					"Oops! Try again.";
			}
		} else {
			document.getElementById("check-header").style.color = "orangered";
			document.getElementById("check-header").innerText =
				"Oops! Try again.";
		}
	}
}

export default function Updation() {
	return (
		<div className="subbundle-main">
			<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
			<h1>Updation in Arrays</h1>
			<p>
				Update operation refers to updating an existing element from the
				array at a given index. Updation is used a lot, especially in
				real-life databases, where entries could be subject to change,
				say your Aadhaar Card Photo.
			</p>
			<p>
				Consider LA is a linear array with N elements and K is a
				positive integer such that K{"<="}N. Following is the algorithm
				to update an element available at the Kth position of LA.
			</p>
			<img src="https://cdn.discordapp.com/attachments/877930443473846324/902561748370984990/unknown.png" />
			<span>Pseudocode for updation in arrays</span>

			<hr />
			<h1>GAME TIME!</h1>
			<div className="subbundle-game-container">
				<h1>
					Update any numbers{" "}
					<u style={{ color: "skyblue" }}>
						divisible by {randomElement}
					</u>{" "}
					by incrementing them by 1. Start from the first element
					<br />
					<br />
					TIP: Click on the first element and then use{" "}
					<u>
						<code>TAB</code>
					</u>{" "}
					or{" "}
					<u>
						<code>SHIFT+TAB</code>
					</u>{" "}
					alternatively to move left or right in the array.
				</h1>
				<div className="upd-arr-div">{arr}</div>
				<button onClick={checkUpdation} id="check-upd">
					Check
				</button>
				<h1 id="check-header"></h1>
			</div>
			<div className="next-previous-div">
				<Link to="/games/arrays/insertion">
					<span>
						{"<"}Prev <b>Insertion in Arrays</b>
					</span>
				</Link>
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				<Link to="/games/arrays/deletion">
					<span>
						<b>Deletion in Arrays </b>Next{">"}
					</span>
				</Link>
			</div>
		</div>
	);
}
